import React from "react";

interface StatusPillProps {
  children: React.ReactNode;
  color?: "accent" | "brand" | "warm";
  className?: string;
}

const colorStyles: Record<string, string> = {
  accent: "bg-accent-dim text-accent",
  brand: "bg-brand-dim text-brand",
  warm: "bg-warm-dim text-warm",
};

const dotStyles: Record<string, string> = {
  accent: "bg-accent animate-pulse-glow",
  brand: "bg-brand",
  warm: "bg-warm",
};

function StatusPill({
  children,
  color = "accent",
  className = "",
}: StatusPillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium font-mono tracking-wide ${colorStyles[color]} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dotStyles[color]}`} />
      {children}
    </span>
  );
}

export default StatusPill;